(() => {
  if (!customElements.get('bba-catalog-more')) {
    customElements.define('bba-catalog-more', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.auto = this.dataset.autoLoad === 'true' && 'IntersectionObserver' in window;
        if (this.auto) {
          const link = this.querySelector('[data-bba-load-more]');
          if (link) {
            link.hidden = true;
            this.observer = new IntersectionObserver((entries) => {
              if (entries[0].isIntersecting && !this.loading && !this.failed && !this.done) this.load(link);
            }, {rootMargin: '600px 0px'});
            this.observer.observe(this);
          }
        }
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-bba-load-more]');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!this.loading) { this.failed = false; this.load(link); }
        });
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
      async load(link) {
        this.loading = true;
        this.controller = new AbortController();
        const grid = this.closest('#ProductGridContainer').querySelector('#product-grid');
        const status = this.querySelector('[role="status"]');
        this.setAttribute('aria-busy', 'true');
        link.setAttribute('aria-disabled', 'true');
        link.textContent = this.dataset.loading;
        status.textContent = this.dataset.loading;
        try {
          const nextUrl = new URL(link.href, location.href);
          for (const [key, value] of new URLSearchParams(location.search)) {
            if (key !== 'page' && key !== 'section_id' && !nextUrl.searchParams.has(key)) nextUrl.searchParams.append(key, value);
          }
          nextUrl.searchParams.set('section_id', grid.dataset.id);
          const response = await fetch(nextUrl, {signal: this.controller.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Unable to load products');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const items = [...page.querySelectorAll('#product-grid > .grid__item')];
          if (!items.length) throw new Error('No products returned');
          if (!this.isConnected || !grid.isConnected) return;
          const fragment = document.createDocumentFragment();
          for (const item of items) fragment.append(document.importNode(item, true));
          grid.append(fragment);
          this.dataset.shown = String(Number(this.dataset.shown) + items.length);
          const next = page.querySelector('[data-bba-load-more]');
          if (next) link.href = next.getAttribute('href');
          else { link.hidden = true; this.done = true; this.observer?.disconnect(); }
          status.textContent = this.dataset.progress.replace('__SHOWN__', this.dataset.shown).replace('__TOTAL__', this.dataset.total);
          document.dispatchEvent(new CustomEvent('bba:collection-products-loaded', {detail:{count:items.length,nextUrl:next?.getAttribute('href')||''}}));
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected) {
            status.textContent = this.dataset.error;
            this.failed = true;
            link.hidden = false;
            this.observer?.disconnect();
          }
        } finally {
          this.loading = false;
          this.removeAttribute('aria-busy');
          link.removeAttribute('aria-disabled');
          link.textContent = this.failed ? this.dataset.error : this.dataset.label;
          if (this.auto && !this.failed && !this.done && this.isConnected) {
            this.observer.unobserve(this);
            requestAnimationFrame(() => {
              if (this.isConnected && !this.loading && !this.done) this.observer.observe(this);
            });
          }
        }
      }
    });
  }
  const catalog = document.querySelector('[data-bba-catalog]');
  if (!catalog || catalog.dataset.enhanced === 'true') return;
  catalog.dataset.enhanced = 'true';
  const preserveContext = () => {
    const params = new URLSearchParams(location.search);
    for (const form of catalog.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile')) {
      form.querySelectorAll('[data-bba-context]').forEach(input => input.remove());
      for (const key of new Set(params.keys())) {
        if (key.startsWith('filter.') || ['sort_by','page','section_id'].includes(key)) continue;
        if ([...form.elements].some(input => input.name === key)) continue;
        for (const value of params.getAll(key)) {
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = key; input.value = value; input.dataset.bbaContext = '';
          form.append(input);
        }
      }
    }
  };
  preserveContext();
  catalog.addEventListener('input', preserveContext, true);
  catalog.addEventListener('click', (event) => {
    const close = event.target.closest('[data-bba-close-filters], [data-bba-show-results]');
    const backdrop = event.target.matches('form.mobile-facets');
    if (!close && !backdrop) return;
    const drawer = event.target.closest('menu-drawer');
    if (!drawer) return;
    event.preventDefault(); event.stopPropagation();
    const summary = drawer.querySelector('summary');
    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
  }, true);
})();
